(() => {
 function initialize(root) {
  if (!root || root.dataset.micReady) return;
  root.dataset.micReady = 'true';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.querySelectorAll('[data-rail]').forEach(button => button.addEventListener('click', () => {
   const id = button.dataset.rail, dir = Number(button.dataset.dir);
   if (id === 'reviews') {
    const slides = [...root.querySelectorAll('.review-slide')];
    const active = slides.findIndex(slide => !slide.hidden);
    slides.forEach((slide, i) => slide.hidden = i !== (active + dir + slides.length) % slides.length);
   } else {
    const rail = root.querySelector('#' + id);
    rail?.scrollBy({left: dir * rail.clientWidth * .8, behavior: reduced() ? 'instant' : 'smooth'});
   }
  }));
  root.querySelectorAll('.rail').forEach(rail => {
   const buttons = [...root.querySelectorAll(`[data-rail="${rail.id}"]`)];
   const update = () => buttons.forEach(button => button.disabled = Number(button.dataset.dir) < 0
    ? rail.scrollLeft <= 1 : rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1);
   rail.addEventListener('scroll', update, {passive: true});
   new ResizeObserver(update).observe(rail); update();
  });
  root.querySelector('.pause-press')?.addEventListener('click', function() {
   const paused = this.getAttribute('aria-pressed') !== 'true';
   this.setAttribute('aria-pressed', paused);
   this.setAttribute('aria-label', paused ? 'Resume press logos' : 'Pause press logos');
   root.querySelector('.press-track').style.animationPlayState = paused ? 'paused' : '';
  });
  root.querySelector('.pause-ticker')?.addEventListener('click', function() {
   const paused = this.getAttribute('aria-pressed') !== 'true';
   this.setAttribute('aria-pressed', paused);
   this.setAttribute('aria-label', paused ? 'Resume benefits ticker' : 'Pause benefits ticker');
   root.querySelector('.ticker-track').style.animationPlayState = paused ? 'paused' : '';
  });
 }
 document.querySelectorAll('[data-mic-landing="craft-kits"]').forEach(initialize);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mic-landing="craft-kits"]').forEach(initialize));
})();
